export const CHANGE_CONFIG = 'CHANGE_CONFIG';
export const CHANGE_PREVIEW_HIDDEN_COMPONENTS = 'CHANGE_PREVIEW_HIDDEN_COMPONENTS';
export const CHANGE_PAGE_TEMPLATE = 'CHANGE_PAGE_TEMPLATE';
export const CHANGE_PAGE_SIZE = 'CHANGE_PAGE_SIZE';
export const CHANGE_PAGE_ORIENTATION = 'CHANGE_PAGE_ORIENTATION';
export const CHANGE_PAGE_MARGINS = 'CHANGE_PAGE_MARGINS';
export const EXPORT_BTN_CLICK = 'EXPORT_BTN_CLICK';
export const EXPORT_DONE = 'EXPORT_DONE';
export const EXPORT_FAILED = 'EXPORT_FAILED';
export const CHANGE_FIX_DIMENSION = 'CHANGE_FIX_DIMENSION';
export var SIZE;
(function (SIZE) {
    SIZE["A4"] = "A4";
    SIZE["A3"] = "A3";
})(SIZE || (SIZE = {}));
export var ORIENTATION;
(function (ORIENTATION) {
    ORIENTATION["PORTRAIT"] = "portrait";
    ORIENTATION["LANDSCAPE"] = "landscape";
})(ORIENTATION || (ORIENTATION = {}));
export var QUERY_STATE;
(function (QUERY_STATE) {
    QUERY_STATE["SUCCESS"] = "SUCCESS";
    QUERY_STATE["FAIL"] = "FAIL";
    QUERY_STATE["WAITING"] = "WAITING";
})(QUERY_STATE || (QUERY_STATE = {}));
//# sourceMappingURL=constants.js.map